export const fastApiEndpoints = {
  conversation: {
    userConversations: {
      url: '/v0/conversations',
    },
    conversationById: (id) => ({
      url: `/v0/conversations/${id}`,
    }),
  },
  image: {
    list: {
      url: '/v0/image',
    },
    search: {
      url: '/v0/image/search',
    },
  },
};
